import { render } from "./ProvvigioniConfig.vue?vue&type=template&id=4d761392&ts=true"
import script from "./ProvvigioniConfig.vue?vue&type=script&lang=ts"
export * from "./ProvvigioniConfig.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__